import { client } from "./client";

// System-admin only: pull + rebuild the frontend on the server. Returns at once;
// the build runs detached. Poll apiRebuildFrontendLog for progress/result.
export function apiRebuildFrontend() {
  return client.post(`/admin/rebuild_frontend`, {});
}

export function apiRebuildFrontendLog() {
  return client.get(`/admin/rebuild_frontend_log`);
}
